import { render, staticRenderFns } from "./CJsonld.vue?vue&type=template&id=275cf6b8&scoped=true&"
import script from "./CJsonld.vue?vue&type=script&lang=ts&"
export * from "./CJsonld.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275cf6b8",
  null
  
)

export default component.exports